import moment from "moment";

export default {
  //防暴力点击
  delayClick(fn) {
    if (this.isClick) return;
    this.isClick = true;
    fn();
    let T = setTimeout(() => {
      clearTimeout(T);
      this.isClick = false;
    }, 1500);
  },
  //防抖
  delayed() {
    let T = 0;
    return (callback, ms) => {
      clearTimeout(T);
      T = setTimeout(callback, ms);
    };
  },
  /**
   * 查询某个时间是距离当前多久
   * @param {时间} time
   */
  beforeTime(time) {
    return moment(time).fromNow();
  },
  beforeTime2(time) {
    return moment().calendar(time);
  },
  formatDate(date) {
    return moment(date).format("YYYY-MM-DD");
  },
  /**
   * el-table :formatter 用方法
   * 0：普通入库，1：期初入库，2：过磅入库，3：盘点入库,4:采购申请入库
   */
  receiveTypeToStr(row, column, cellValue, index) {

    let str = "";
    switch (cellValue) {
      case 0:
        str = "普通入库";
        break;
      case 100:
        str = "期初入库";
        break;
      case 2:
        str = "过磅入库";
        break;
      case 300:
        str = "盘点入库";
        break;
      case 400:
        str = "采购申请入库";
        break;
      default:
        str = "未知类型";
        break;
    }
    return str;
  },
    /**
   * el-table :formatter 用方法
   * 0：普通入库，1：期初入库，2：过磅入库，3：盘点入库,4:采购申请入库
   */
     deliverTypeToStr(row, column, cellValue, index) {
      let str = "";
      switch (cellValue) {
        case 0:
          str = "普通出库";
          break;
        case 100:
          str = "期初出库";
          break;
        case 200:
          str = "过磅出库";
          break;
        case 300:
          str = "盘点出库";
          break;
        case 400:
          str = "采购申请出库";
          break;
        default:
          str = "未知类型";
          break;
      }
      return str;
    },
  /**
   * 0：蓝字单，1：红字单
   * @param {*} flag 
   * @returns 
   */
  rbFlag(row, column, cellValue, index) {
    let str = "";
    switch (cellValue) {
      case 0:
        str = "蓝字单";
        break;
      case 1:
        str = "红字单";
        break;
      default:
        str = "未知单据";
        break;
    }
    return str;
  },
};
